import React from "react"
import { Link, graphql } from "gatsby"
import { PrismicRichText } from '@prismicio/react'
import Copyright from '../components/copyright'
import Footer from '../components/footer'
import Contact from '../components/contact'
import Seo from '../components/seo'
import { linkResolver } from '../utils/link_resolver'
import Banner from '../components/banner'
import Header from '../components/header'
import Nav from '../components/nav'

export const query = graphql`
  query {
    prismicContact {
      data {
        body {
          richText
        }
        page_title
        meta_description
        image {
          gatsbyImageData
          alt
        }
        heading {
          text
        }
      }
    }
  }
`

const ContactPage = ({data}) => {
  const entry = data.prismicContact
  if (!entry) return null
  return (
  <>
    <Seo title={entry.data.page_title} description={entry.data.meta_description} image="" pathname={linkResolver(entry.data)} />  
    <Nav />
    <Header />
    <Banner image={entry.data.image} />
    <div className="w-full font-sans py-12 sm:py-24">
      <div className="w-9/12 mx-auto max-w-screen-2xl">
        <div className="flex-none md:flex gap-24 justify-between">
          <div className="w-full md:w-8/12 prose text-dark-green md:prose-lg leading-relaxed">
            <h1>{entry.data.heading.text}</h1>
            <PrismicRichText field={entry.data.body.richText} />  
          </div>
          <div className="w-full md:w-4/12 mt-24 md:mt-0">
            <div className="bg-grey-e prose p-6 leading-relaxed">
              <h3>Lawyers &amp; Patent Attorneys</h3>
              <p>McCabes are experts in all aspects of Australian and New Zealand IP rights, protection and law. We act for clients in NZ, Australia and internationally.</p>
              <p>For advice on securing, protecting and defending your IP assets, please contact us today.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="w-full font-sans pb-6">
      <div className="w-9/12 mx-auto max-w-screen-2xl">
        <div className="prose text-dark-green prose-lg leading-relaxed">
          <h2>Locations</h2>
        </div>
      </div>
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 mb-24 gap-3">
      <div className="w-full font-sans relative">
        <div className="absolute z-10 right-12 top-12">
          <span className="text-2xl font-bold text-white bg-dark-green px-6 py-3">Wellington</span>
        </div>
        <iframe className="relative w-full h-144 border-none" title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2998.24143295679!2d174.7743031154225!3d-41.2818496792739!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d38ae2b22e21c7b%3A0x35c83e1206fd89a1!2s5%2038%2F42%20Waring%20Taylor%20Street%2C%20Wellington%20Central%2C%20Wellington%206011!5e0!3m2!1sen!2snz!4v1651286312201!5m2!1sen!2snz" allowFullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
      <div className="w-full font-sans relative">
        <div className="absolute z-10 right-12 top-12">
          <span className="text-2xl font-bold text-white bg-dark-green px-6 py-3">Auckland</span>
        </div>
        <iframe className="relative w-full h-144 border-none" title="map" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3195.4948640350735!2d174.77188511528942!3d-36.782683779952244!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x6d0d37626252cd91%3A0x4897764b64ce2928!2s187%20Hurstmere%20Road%2C%20Takapuna%2C%20Auckland%200622!5e0!3m2!1sen!2snz!4v1651289256422!5m2!1sen!2snz" allowFullscreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
    <Contact image={entry.data.image} />
    <Footer />
    <Copyright />
  </>
  )
}

export default ContactPage